import type { WidgetPosition } from '../../../../posthog-conversations-types'
import { getStyles } from './styles'

interface OpenChatButtonProps {
    primaryColor: string
    position?: WidgetPosition
    handleToggleOpen: () => void
    unreadCount?: number
}

export const OpenChatButton = ({
    primaryColor,
    position = 'bottom_right',
    handleToggleOpen,
    unreadCount = 0,
}: OpenChatButtonProps) => {
    const styles = getStyles(primaryColor, position)
    const displayCount = unreadCount > 99 ? '99+' : unreadCount.toString()

    return (
        <div style={styles.widget}>
            <div style={styles.buttonContainer}>
                <button
                    style={styles.button}
                    onClick={handleToggleOpen}
                    aria-label={unreadCount > 0 ? `Open chat (${unreadCount} unread)` : 'Open chat'}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)'
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)'
                    }}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 13.93 2.6 15.71 3.64 17.18L2.5 21.5L7.04 20.42C8.46 21.28 10.17 21.75 12 21.75C17.52 21.75 22 17.27 22 11.75C22 6.23 17.52 2 12 2Z"
                            fill="currentColor"
                        />
                    </svg>
                </button>
                {unreadCount > 0 && <div style={styles.unreadBadge}>{displayCount}</div>}
            </div>
        </div>
    )
}
